import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Lead } from 'src/app/_types/lead.types';
import { InsuranceType } from 'src/app/enums/insurance-type.enum';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { AnimalMetadataV2Component } from '../animal-metadata-v2/animal-metadata-v2.component';
import { BuildingMetadataV2Component } from '../building-metadata-v2/building-metadata-v2.component';
import { BusinessBasicMetadataV2Component } from '../business-basic-metadata-v2/business-basic-metadata-v2.component';
import { BusinessAccidentMetadataV2Component } from '../business-metadatas-v2/business-accident-metadata-v2/business-accident-metadata-v2.component';
import { BusinessCyberMetadataV2Component } from '../business-metadatas-v2/business-cyber-metadata-v2/business-cyber-metadata-v2.component';
import { BusinessFleetMetadataV2Component } from '../business-metadatas-v2/business-fleet-metadata-v2/business-fleet-metadata-v2.component';
import { BusinessHealthMetadataV2Component } from '../business-metadatas-v2/business-health-metadata-v2/business-health-metadata-v2.component';
import { BusinessLegalProtectionMetadataV2Component } from '../business-metadatas-v2/business-legal-protection-metadata-v2/business-legal-protection-metadata-v2.component';
import { BusinessRetirementMetadataV2Component } from '../business-metadatas-v2/business-retirement-metadata-v2/business-retirement-metadata-v2.component';
import { BusinessTechnicalInstallationMetadataV2Component } from '../business-metadatas-v2/business-technical-installation-metadata-v2/business-technical-installation-metadata-v2.component';
import { BusinessThingsMetadataV2Component } from '../business-metadatas-v2/business-things-metadata-v2/business-things-metadata-v2.component';
import { BusinessTransportMetadataV2Component } from '../business-metadatas-v2/business-transport-metadata-v2/business-transport-metadata-v2.component';
import { BusinessVehicleMetadataV2Component } from '../business-metadatas-v2/business-vehicle-metadata-v2/business-vehicle-metadata-v2.component';
import { RcCompanyMetadataV2Component } from '../business-metadatas-v2/rc-company-metadata-v2/rc-company-metadata-v2.component';
import { CancellationMetadataV2Component } from '../cancellation-metadata-v2/cancellation-metadata-v2.component';
import { CentralisationMetadataV2Component } from '../centralisation-metadata-v2/centralisation-metadata-v2.component';
import { CollaboratorMetadataV2Component } from '../collaborator-metadata-v2/collaborator-metadata-v2.component';
import { ConstructionMetadataV2Component } from '../construction-metadata-v2/construction-metadata-v2.component';
import { HealthMetadataV2Component } from '../health-metadata-v2/health-metadata-v2.component';
import { HouseholdMetadataV2Component } from '../household-metadata-v2/household-metadata-v2.component';
import { LegalProtectionMetadataV2Component } from '../legal-protection-metadata-v2/legal-protection-metadata-v2.component';
import { PolicyUpdateMetadataV2Component } from '../policy-update-metadata-v2/policy-update-metadata-v2.component';
import { ThirdPillarMetadataV2Component } from '../third-pillar-metadata-v2/third-pillar-metadata-v2.component';
import { TravelMetadataV2Component } from '../travel-metadata-v2/travel-metadata-v2.component';
import { ValuableObjectsMetadataV2Component } from '../valuable-objects-metadata-v2/valuable-objects-metadata-v2.component';
import { VehicleMetadataV2Component } from '../vehicle-metadata-v2/vehicle-metadata-v2.component';

@Component({
  selector: 'app-lead-metadata-details-v2',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    HealthMetadataV2Component,
    TravelMetadataV2Component,
    AnimalMetadataV2Component,
    BuildingMetadataV2Component,
    CancellationMetadataV2Component,
    CentralisationMetadataV2Component,
    ConstructionMetadataV2Component,
    HouseholdMetadataV2Component,
    LegalProtectionMetadataV2Component,
    ThirdPillarMetadataV2Component,
    ValuableObjectsMetadataV2Component,
    VehicleMetadataV2Component,
    RcCompanyMetadataV2Component,
    BusinessThingsMetadataV2Component,
    BusinessAccidentMetadataV2Component,
    BusinessHealthMetadataV2Component,
    BusinessRetirementMetadataV2Component,
    BusinessVehicleMetadataV2Component,
    PolicyUpdateMetadataV2Component,
    CollaboratorMetadataV2Component,
    BusinessCyberMetadataV2Component,
    BusinessLegalProtectionMetadataV2Component,
    BusinessFleetMetadataV2Component,
    BusinessTransportMetadataV2Component,
    BusinessTechnicalInstallationMetadataV2Component,
    BusinessBasicMetadataV2Component,
  ],
  templateUrl: './lead-metadata-details-v2.component.html',
})
export class LeadMetadataDetailsV2Component {
  @Input()
  lead!: Lead;

  @Input()
  originalLead?: Lead;

  @Output()
  done = new EventEmitter<void>();

  InsuranceType = InsuranceType;
}
